<template>
  <div id="app">
    <router-view  />
  </div>
</template>

<script>
// @ is an alias to /src



// import axios from "axios";

export default {
  components: {
  
  },
  
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Karla&display=swap');

#app{
  font-family: 'Karla', sans-serif;
  -webkit-font-smoothing: antialiased;

}
</style>
